import React, { useState, useEffect, useRef } from 'react';

const ProjecaoDropdown = ({ regraNome, isLoading, isOpen, onToggle, onProject }) => {
    const [showCustomInput, setShowCustomInput] = useState(false);
    const [valorCustom, setValorCustom] = useState('');
    const [validationError, setValidationError] = useState(null);
    const dropdownRef = useRef(null);

    // Fechar dropdown ao clicar fora
    useEffect(() => {
        if (!isOpen) return;
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                onToggle();
                setShowCustomInput(false);
                setValorCustom('');
                setValidationError(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen, onToggle]);

    const handleSelectOption = (tipoProjecao) => {
        if (tipoProjecao === 'VALOR_PERSONALIZADO') {
            setShowCustomInput(true);
            return;
        }
        onProject(regraNome, tipoProjecao, null);
        setShowCustomInput(false);
    };

    const handleCustomSubmit = () => {
        const valor = parseFloat(valorCustom.replace(/\./g, '').replace(',', '.'));
        if (isNaN(valor) || valor <= 0) {
            setValidationError('Valor deve ser maior que zero');
            return;
        }
        setValidationError(null);
        onProject(regraNome, 'VALOR_PERSONALIZADO', valor);
        setShowCustomInput(false);
        setValorCustom('');
    };

    if (isLoading) {
        return (
            <div className="d-flex align-items-center mt-3">
                <div className="spinner-border spinner-border-sm text-warning me-2" role="status">
                    <span className="visually-hidden">Projetando...</span>
                </div>
                <small className="text-muted">Calculando projeção...</small>
            </div>
        );
    }

    return (
        <div className="dropdown mt-3" ref={dropdownRef}>
            <button
                className="btn btn-warning btn-sm dropdown-toggle"
                type="button"
                onClick={onToggle}
            >
                Projetar
            </button>
            {isOpen && (
                <div className="dropdown-menu show" style={{ display: 'block' }}>
                    <button
                        className="dropdown-item"
                        onClick={() => handleSelectOption('ULTIMA_REMUNERACAO')}
                    >
                        Última remuneração
                    </button>
                    <button
                        className="dropdown-item"
                        onClick={() => handleSelectOption('SALARIO_MINIMO')}
                    >
                        Salário mínimo
                    </button>
                    <button
                        className="dropdown-item"
                        onClick={() => handleSelectOption('VALOR_PERSONALIZADO')}
                    >
                        Valor personalizado
                    </button>
                    {showCustomInput && (
                        <div className="px-3 py-2">
                            <div className="input-group input-group-sm">
                                <span className="input-group-text">R$</span>
                                <input
                                    type="text"
                                    className={`form-control ${validationError ? 'is-invalid' : ''}`}
                                    placeholder="0,00"
                                    value={valorCustom}
                                    onChange={(e) => {
                                        setValorCustom(e.target.value);
                                        setValidationError(null);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') handleCustomSubmit();
                                    }}
                                    autoFocus
                                />
                                <button
                                    className="btn btn-warning btn-sm"
                                    onClick={handleCustomSubmit}
                                >
                                    Calcular
                                </button>
                            </div>
                            {validationError && (
                                <div className="text-danger small mt-1">{validationError}</div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ProjecaoDropdown;
